<template>
  <div class="l-factory">
    <header class="l-header">
      <div class="header__items">
        <div class="header__item--sales">
          <Sales v-bind:passed-test-state="passedTestState" />
        </div>
        <div class="header__item--visitor">
          <Visitor v-bind:passed-test-state="passedTestState" />
        </div>
      </div>
      <div class="header__name">
        <p><em>〇山△郎</em>のお店</p>
      </div>
    </header>
    
    <main class="l-main">

      <div class="l-stage">
        <Stage v-bind:passed-test-state="passedTestState" />
      </div>

      <div class="l-study-nav">
        <div v-on:click="openStudy()" class="study-nav__inner">
          <img :src="`${staticPath}img/factory/pic_btn_study.png`">
          <button class="study-nav__button"></button>
        </div>
      </div>
  
    </main>

    <footer class="l-footer">
      <div class="footer__items">
        <div class="footer__item">
          <Ranking v-bind:passed-test-state="passedTestState" />
        </div>
        <div class="footer__item">
          <Service v-bind:passed-test-state="passedTestState" />
        </div>
      </div>
    </footer>

    <transition>
      <div v-if="isModeStudy" class="l-study">
        <PageStudy v-on:close-page="closeStudy()" />
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/factory.scss';
</style>

<script>
  import Constant from '@/constant';
  import Sales from '@/components/Factory/Sales';
  import Visitor from '@/components/Factory/Visitor';
  import Stage from '@/components/Factory/Stage';
  import Ranking from '@/components/Factory/Ranking';
  import Service from '@/components/Factory/Service';
  import PageStudy from '@/views/PageStudy';

  export default {
    name: 'Factory',

    components: {
      Sales,
      Visitor,
      Stage,
      Ranking,
      Service,
      PageStudy
    },

    data() {
      return {
        staticPath: Constant.STATICPATH,
        isModeStudy: false,
        passedTestState: 0  // 合格テストリストの状態監視用
      }
    },

    created() {

      this.isModeStudy = this.$route.params.isModeStudy;
    },

    methods: {

      openStudy(){
        this.isModeStudy = true;
      },

      closeStudy() {
        this.isModeStudy = false;

        // 合否にかかわらず状態変化
        this.passedTestState++;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/PageFactory.vue